import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { footer } from '../../constants/core.constant';
import { UserService } from '../../services/user-service/user-service.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';


@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})

export class FooterComponent implements OnInit {
  currentPortal: string;
  constants = footer;
  portalType: string = '';
  userTypeId: any;
  userDetails: any;
  userRole: any;
  logoPath: string;
  isAuthenticated: boolean = false;
  loading: boolean = true;
  permissionsData: any;
 isServiceRequestUser: boolean = false;
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private readonly router: Router,
    private readonly userService: UserService
  ) {
    
  }

  ngOnInit(): void {
    this.getUserInfo();
    this.setLogoPath();
  }

  /**
 * setLogoPath() - Sets the logoPath property based on the current environment.
 */
  private setLogoPath() : void {
    const currentEnvironment = environment.environment;
    switch (currentEnvironment) {
      case this.constants.dev:
        this.logoPath = 'https://greenlight-dev.wbd.com/assets/images/wb-logo-black.svg';
        break;
      case this.constants.qa:
        this.logoPath = 'https://greenlight-qa.wbd.com/assets/images/wb-logo-black.svg';
        break;
      default:
        this.logoPath = 'https://greenlight-dev.wbd.com/assets/images/wb-logo-black.svg';
        break;
    }
  }
  /**
   * redirectToDashboard()- Redirects the user to a specific dashboard based on portal type as mentioned
   */
  redirectToDashboard(): void {
    switch (this.portalType) {
      case this.constants.customer:
        this.router.navigate(['/feature/customer-dashboard/overview']);
        break;
      case this.constants.wbso:
        this.router.navigate(['/feature/studio-dashboard/Mydashboard']);
        break;
      case this.constants.ar:
        this.router.navigate(['/feature/ar-dashboard/overview']);
        break;
      default:
        console.warn(this.constants.unknownType);
    }
  }

  /**
   * navigateOnLogoClick()- Navigates the user based on their login status
   */
  navigateOnLogoClick(): void {
    if (this.isAuthenticated) {
      this.redirectToDashboard();
    } else {
      this.router.navigate(['/homepage']);
    }
  }

  /**
   * setPortalType()- Sets the portal type based on user type and roles
   */
  setPortalType(): void {
    if (this.userTypeId == 1) {
      this.portalType = this.constants.customer;
    } else if (this.userTypeId == 2) {
      if (Array.isArray(this.userDetails.roles) && this.userDetails.roles.includes(this.constants.AR)) {
        this.portalType = this.constants.ar;
      } else {
        this.portalType = this.constants.wbso;
      }
    }
  }

  /**
   * getUserInfo()- Fetches user info and updates component state
   */
  getUserInfo(): void {
    const userProfile = JSON.parse(localStorage.getItem(this.constants.userprofile));
    if (userProfile) {
      this.userTypeId = userProfile.userTypeId;
      this.userDetails = userProfile;
      this.permissionsData = { ...userProfile.roleAssigned };
      this.setPortalType();
      this.isServiceRequestUser = this.permissionsData['serviceRequestUser'];
      this.isAuthenticated = true;
    }
    this.userService.userInfo$.subscribe((userInfo) => {
      if (userInfo) {
        let userDetails = userInfo?.userProfileDTO;
        this.userTypeId = userDetails?.userTypeId;
        this.userDetails = userDetails;
        this.permissionsData = { ...userDetails.roleAssigned };
        this.setPortalType();
        this.isServiceRequestUser = this.permissionsData['serviceRequestUser'];

        this.isAuthenticated = true;
      }
      this.loading = false;
    });
  }
}
